import { LOGIN_ROUTE } from "../routes/RoutesPathes";

let navigateFunction = null;

export const setRedirect = (navigate) => {
  navigateFunction = navigate;
};

export const redirectToLogin = (location) => {
  if (navigateFunction) {
    navigateFunction(LOGIN_ROUTE, { state: { from: location }, replace: true });
  }
};
